import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { removeTrace } from "../../actions/";

const Trash = props => (
  <button
    onClick={props.removeTrace}
    className="btn btn-danger"
    title="Effacer le tracé en cours"
  >
    <span className="glyphicon glyphicon-trash" />
  </button>
);

Trash.propTypes = {
  removeTrace: PropTypes.func.isRequired
};
const mapDispatchToProps = dispatch =>
  bindActionCreators({ removeTrace }, dispatch);

export default connect(null, mapDispatchToProps)(Trash);
